import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CONFIG from './environmentConfig/index'
import Amplify from 'aws-amplify';

Amplify.configure({
  // OPTIONAL - if your API requires authentication
  API: {
    endpoints: [
      {
        name: CONFIG.API_NAME,
        endpoint: CONFIG.API_BASE_URL,
        service: "lambda",
        region: CONFIG.BACKEND_REGION
      }
    ]
  }
});


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
